import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "../components/Logo";
import { PRIVACY_POLICY_VERSION } from "./billing/billing";

// PrivacyPolicy is the version named on the registration checkbox.
const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto">
        <Logo className="max-w-xs" />
        <h1 className="mt-6 text-3xl leading-9 font-extrabold text-gray-900">Privacy policy</h1>
        <p className="mt-2 text-sm text-gray-500">Version {PRIVACY_POLICY_VERSION}</p>

        <div className="mt-8 bg-white shadow sm:rounded-lg px-4 py-6 sm:px-8 space-y-8 text-sm leading-6 text-gray-700">
          <section>
            <h2 className="text-lg font-medium text-gray-900">Who is responsible</h2>
            <p className="mt-2">
              searchanalyzer.io is a product of SMC Internet UG (haftungsbeschränkt), Erich-Weinert-Straße 132,
              10409 Berlin, Germany. You can reach us at{" "}
              <a className="text-blue-600 hover:text-blue-800" href="mailto:kontakt@searchanalyzer.io">
                kontakt@searchanalyzer.io
              </a>
              . The managing director is Stephan Czysch.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-medium text-gray-900">Account</h2>
            <p className="mt-2">
              When you register we store your name, email address, and a hash of the password you chose. We also
              store the plan you selected, the time you accepted this policy, and this version number. You can sign
              in after you confirm the email address and we approve the account.
            </p>
            <p className="mt-2">
              If you do not confirm the email, we delete the registration 14 days after it was created, including
              any invoice details submitted with it.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-medium text-gray-900">Invoice details</h2>
            <p className="mt-2">
              If you choose a paid membership, ask to continue a trial, or request an upgrade, we store the invoice
              details you enter: salutation, company, street, postal code, city, country, billing email, number of
              projects, an optional message, and an optional VAT ID. We use them to prepare the invoice, which we
              create and send manually. The tool does not charge a payment card.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-medium text-gray-900">Google Search Console</h2>
            <p className="mt-2">
              If you connect a Google account, we store the access Google grants and use it to read Search Console
              data for the properties you select. That includes search analytics and URL inspection results. We keep
              this data so the tool can show your reports and send notifications you have not turned off. Google
              processes the sign-in under its own terms.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-medium text-gray-900">Messages</h2>
            <p className="mt-2">
              We email the confirmation link, the decision on your registration, and the messages that belong to a
              free trial. Those messages are required to run the account. Further product notifications can be turned
              off with the unsubscribe link in the message, where that link is offered.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-medium text-gray-900">Technical data</h2>
            <p className="mt-2">
              For a registration or a new confirmation link we store the IP address and the email address for up to
              48 hours, so repeated requests can be limited. Your session token stays in the browser until you sign
              out or it expires. A color-mode cookie remembers whether the app is shown in light or dark. We do not
              use it for advertising.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-medium text-gray-900">Why we process the data</h2>
            <p className="mt-2">
              We process the account, the invoice details, and the Search Console data you connect in order to
              provide the account you requested. We process the short-lived signup attempts and the display cookie
              to keep the service reliable and usable. The checkbox on the registration form records that this
              version was shown to you.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-medium text-gray-900">How long we keep it</h2>
            <p className="mt-2">
              We keep the account, its projects, and the invoice details while the account exists and for as long as
              commercial and tax duties require the invoice records. You can delete the account in Account settings. Signup
              attempts are deleted after 48 hours. An unconfirmed registration is deleted after 14 days.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-medium text-gray-900">Your rights</h2>
            <p className="mt-2">
              You can ask for access to your data, a correction, deletion, restriction of processing, or a copy of
              the data you provided. You can also object to processing that is based on our legitimate interest. You
              can lodge a complaint with the Berliner Beauftragte für Datenschutz und Informationsfreiheit. Write to{" "}
              <a className="text-blue-600 hover:text-blue-800" href="mailto:kontakt@searchanalyzer.io">
                kontakt@searchanalyzer.io
              </a>{" "}
              for any of these requests.
            </p>
          </section>
        </div>

        <p className="mt-6 text-sm">
          <Link to="/register" className="text-indigo-600 hover:text-indigo-500">
            Back to registration
          </Link>
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
